/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import GlobalSVG from "../../utils/GlobalSVG";
import API from "../../utils/API";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";

function Client() {
    const [client, setClient] = useState({
        cpf: "",
        name: "",
        phone_number: "",
        email: "",
        cep: "",
        address_street: "",
        address_state: "",
        address_number: "",
        address_neighborhood: "",
        address_extra_info: "",
        address_city: ""
    });

    const mapping = {
        "cpf": "CPF",
        "name": "Nome",
        "phone_number": "Telefone",
        "email": "Email",
        "cep": "CEP",
        "address_street": "Rua",
        "address_state": "Estado",
        "address_number": "Número",
        "address_neighborhood": "Bairro",
        "address_extra_info": "Complemento",
        "address_city": "Cidade"
    }


    useEffect(() => {
        if (!localStorage.getItem('yc_usr_dt_ls')) {
            window.location.href = '/login';
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClient(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === "cpf") {
            Swal.fire({
                title: 'Buscando cliente',
                text: 'Aguarde um momento',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
            API.getClient(API.cancelToken(), value).then(res => {
                const new_client = {
                    cpf: res.data.cpf,
                    name: res.data.name,
                    phone_number: res.data.phone_number,
                    email: res.data.email,
                    cep: res.data.cep,
                    address_street: res.data.address_street,
                    address_state: res.data.address_state,
                    address_number: res.data.address_number,
                    address_neighborhood: res.data.address_neighborhood,
                    address_extra_info: res.data.address_extra_info,
                    address_city: res.data.address_city
                }
                setClient(new_client)
                Swal.close()
            }).catch(err => {
                Swal.close()
                console.log(err)
            })
        }

        if (name === "cep") {
            API.getAddress(API.cancelToken(), value).then(res => {
                console.log(res.data)
                const new_client = {
                    cpf: res.data.cpf,
                    name: res.data.name,
                    phone_number: res.data.phone_number,
                    email: res.data.email,
                    cep: res.data.cep,
                    address_number: res.data.address_number,
                    address_extra_info: res.data.address_extra_info,
                    address_street: res.data.logradouro,
                    address_state: res.data.uf,
                    address_neighborhood: res.data.bairro,
                    address_city: res.data.localidade
                }
                setClient(new_client)
                Swal.close()
            }).catch(err => {

            })
        }
    };


    const postClient = () => {
        Swal.fire({
            title: 'Salvando cliente',
            text: 'Aguarde um momento',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        API.postClient(API.cancelToken(), client).then(res => {
            Swal.close()
            localStorage.setItem('client', JSON.stringify(client))
            localStorage.setItem('client_id', JSON.stringify(res.data.client_id))


        }).catch(err => {
            console.log(err)
            Swal.close()
        });
    };

    const getMask = (key) => {
        if (key === "cpf") {
            return "999.999.999-99"
        }
        if (key === "phone_number") {
            return "(99) 99999-9999"
        }
        if (key === "cep") {
            return "99999-999"
        }

    }

    return (
        <div className="flex w-full h-full pt-8 px-20 pb-24 items-center gap-8 self-stretch">
            <div className="flex w-full h-auto py-6 flex-col items-center gap-8 self-stretch bg-[#FFF] rounded ">
                    <div className="flex w-full items-start gap-6 self-stretch  ">
                        <div className="flex flex-col w-full items-start px-16">
                            <div className="flex items-center justify-between self-stretch">
                                <div className="flex px-6 py-2 justify-center items-center gap-3 ">
                                    <p className="text-2xl font-medium">Cliente </p>
                                    {/* <p className="text-sm text-[#00000073]">Dados encontrados</p> */}
                                </div>
                            </div>
                            <div className="flex pt-4 px-24 flex-col w-full items-start gap-6 self-stretch">
                                {Object.keys(client).map((key) => (
                                    <div className="flex flex-col gap-2.5 w-full" key={key}>
                                        <label className="text-sm font-medium">{mapping[key].toUpperCase() ? mapping[key].toUpperCase() : ''}:</label>
                                        <InputMask
                                            type="text"
                                            name={key}
                                            value={client[key]}
                                            mask={getMask(key)}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="border rounded px-3 py-2 w-full"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="flex px-3 py-6 h-16 w-full flex-row justify-end items-center gap-4 self-stretch">
                        <div className="flex h-10 w-28 px-2 py-4 justify-center items-center gap-2.5 cursor-pointer">
                            Cancelar
                        </div>
                        <div className="flex h-10 w-36 px-2 py-4 justify-center items-center bg-[#389E0D] gap-2.5 border border-[#389E0D] rounded shadow-sm cursor-pointer" onClick={postClient}>
                            {GlobalSVG.arrowRight()}
                            <p className="text-[#FFF]">Editar</p>
                        </div>
                    </div>
                </div>
            </div>

    );
}
export default Client;